import { useAiSocket } from './useAiSocket';
import { useAiChats } from './useAiChats';

export function useAiAssistant(active: boolean) {
  const { send } = useAiSocket(active);
  const { refresh, open, newChat, rate } = useAiChats(active);
  return { send, rate, newChat, openChat: open, refreshChats: refresh };
}
